import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});

export default styles;
